import script from "./RtoView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RtoView.vue?vue&type=script&lang=ts&setup=true"

import "./RtoView.vue?vue&type=style&index=0&id=bd350c9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd350c9e"]])

export default __exports__